import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";
import { RouteDrawer } from "#/components/route-drawer";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/reports/flow/$id/step/3/$class/drawer",
)({
  component: ReportsDrawerLayout,
  errorComponent: ReportsDrawerError,
});

function ReportsDrawerLayout() {
  const navigate = useNavigate();

  return (
    <RouteDrawer
      // Non-modal so the notities table stays clickable: opening another leerling swaps
      // the drawer content instead of requiring close-then-reopen.
      modal={false}
      onClose={() => {
        // Close = return to the class notities page; drawer-only search params are dropped.
        void navigate({
          from: Route.fullPath,
          to: "/$locale/{-$schoolyear}/$school/reports/flow/$id/step/3/$class",
          params: (prev) => prev,
          replace: true,
          resetScroll: false,
          viewTransition: true,
        });
      }}
    >
      <Outlet />
    </RouteDrawer>
  );
}

function ReportsDrawerError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
